module.exports = __webpack_public_path__ + "media/images/Featured-desktop-76bda6bc4d624466cfbcf96097571261.webp";